import { render, staticRenderFns } from "./PortalComponent.vue?vue&type=template&id=5446f1a4"
import script from "./PortalComponent.vue?vue&type=script&lang=js"
export * from "./PortalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports